"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _GlobalPreferences = _interopRequireDefault(require("./GlobalPreferences"));
var _IdentificationDetails = _interopRequireDefault(require("./IdentificationDetails"));
var _PersonalDetails = _interopRequireDefault(require("./PersonalDetails"));
var _Role = _interopRequireDefault(require("./Role"));
var _User = _interopRequireDefault(require("./User"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The Employee model module.
 * @module model/Employee
 * @version 3.0
 */
var Employee = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>Employee</code>.
   * @alias module:model/Employee
   */
  function Employee() {
    _classCallCheck(this, Employee);
    Employee.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(Employee, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>Employee</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Employee} obj Optional instance to populate.
     * @return {module:model/Employee} The populated <code>Employee</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new Employee();
        if (data.hasOwnProperty('employeeId')) {
          obj['employeeId'] = _ApiClient["default"].convertToType(data['employeeId'], 'Number');
        }
        if (data.hasOwnProperty('employeeLegacyId')) {
          obj['employeeLegacyId'] = _ApiClient["default"].convertToType(data['employeeLegacyId'], 'String');
        }
        if (data.hasOwnProperty('organizationName')) {
          obj['organizationName'] = _ApiClient["default"].convertToType(data['organizationName'], 'String');
        }
        if (data.hasOwnProperty('operatorLevelName')) {
          obj['operatorLevelName'] = _ApiClient["default"].convertToType(data['operatorLevelName'], 'String');
        }
        if (data.hasOwnProperty('levelId')) {
          obj['levelId'] = _ApiClient["default"].convertToType(data['levelId'], 'Number');
        }
        if (data.hasOwnProperty('identificationDetails')) {
          obj['identificationDetails'] = _IdentificationDetails["default"].constructFromObject(data['identificationDetails']);
        }
        if (data.hasOwnProperty('personalDetails')) {
          obj['personalDetails'] = _PersonalDetails["default"].constructFromObject(data['personalDetails']);
        }
        if (data.hasOwnProperty('globalPreferences')) {
          obj['globalPreferences'] = _GlobalPreferences["default"].constructFromObject(data['globalPreferences']);
        }
        if (data.hasOwnProperty('user')) {
          obj['user'] = _User["default"].constructFromObject(data['user']);
        }
        if (data.hasOwnProperty('roleName')) {
          obj['roleName'] = _ApiClient["default"].convertToType(data['roleName'], 'String');
        }
        if (data.hasOwnProperty('role')) {
          obj['role'] = _Role["default"].constructFromObject(data['role']);
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>Employee</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Employee</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['employeeLegacyId'] && !(typeof data['employeeLegacyId'] === 'string' || data['employeeLegacyId'] instanceof String)) {
        throw new Error("Expected the field `employeeLegacyId` to be a primitive type in the JSON string but got " + data['employeeLegacyId']);
      }
      // ensure the json data is a string
      if (data['organizationName'] && !(typeof data['organizationName'] === 'string' || data['organizationName'] instanceof String)) {
        throw new Error("Expected the field `organizationName` to be a primitive type in the JSON string but got " + data['organizationName']);
      }
      // ensure the json data is a string
      if (data['operatorLevelName'] && !(typeof data['operatorLevelName'] === 'string' || data['operatorLevelName'] instanceof String)) {
        throw new Error("Expected the field `operatorLevelName` to be a primitive type in the JSON string but got " + data['operatorLevelName']);
      }
      // validate the optional field `identificationDetails`
      if (data['identificationDetails']) {
        // data not null
        _IdentificationDetails["default"].validateJSON(data['identificationDetails']);
      }
      // validate the optional field `personalDetails`
      if (data['personalDetails']) {
        // data not null
        _PersonalDetails["default"].validateJSON(data['personalDetails']);
      }
      // validate the optional field `globalPreferences`
      if (data['globalPreferences']) {
        // data not null
        _GlobalPreferences["default"].validateJSON(data['globalPreferences']);
      }
      // validate the optional field `user`
      if (data['user']) {
        // data not null
        _User["default"].validateJSON(data['user']);
      }
      // ensure the json data is a string
      if (data['roleName'] && !(typeof data['roleName'] === 'string' || data['roleName'] instanceof String)) {
        throw new Error("Expected the field `roleName` to be a primitive type in the JSON string but got " + data['roleName']);
      }
      // validate the optional field `role`
      if (data['role']) {
        // data not null
        _Role["default"].validateJSON(data['role']);
      }
      return true;
    }
  }]);
}();
/**
 * @member {Number} employeeId
 */
Employee.prototype['employeeId'] = undefined;

/**
 * @member {String} employeeLegacyId
 */
Employee.prototype['employeeLegacyId'] = undefined;

/**
 * @member {String} organizationName
 */
Employee.prototype['organizationName'] = undefined;

/**
 * @member {String} operatorLevelName
 */
Employee.prototype['operatorLevelName'] = undefined;

/**
 * @member {Number} levelId
 */
Employee.prototype['levelId'] = undefined;

/**
 * @member {module:model/IdentificationDetails} identificationDetails
 */
Employee.prototype['identificationDetails'] = undefined;

/**
 * @member {module:model/PersonalDetails} personalDetails
 */
Employee.prototype['personalDetails'] = undefined;

/**
 * @member {module:model/GlobalPreferences} globalPreferences
 */
Employee.prototype['globalPreferences'] = undefined;

/**
 * @member {module:model/User} user
 */
Employee.prototype['user'] = undefined;

/**
 * @member {String} roleName
 */
Employee.prototype['roleName'] = undefined;

/**
 * @member {module:model/Role} role
 */
Employee.prototype['role'] = undefined;
var _default = exports["default"] = Employee;